import React, {FC} from "react";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportItemData} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportItemDataPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportItemData}
            searchHeader={getPageNameByPageId(PageEnum.ReportItemsData)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportItemsData}
        />
    );
};
